import { AxiosResponse } from 'axios'
import { TNotificationStatus } from './common/model'

export type Nullable<T> = T | null

export interface IValidationCallbackProps {
  success?: boolean
  fields?: any
  errorMessage?: {
    status: TNotificationStatus
    title: string
    message: string
  }
}

export type IValidationCallback = (data: IValidationCallbackProps) => void

export type ICallback = (data?: any) => void

export interface ActionCallback<T = any, C = IValidationCallback> {
  type: string
  payload: T
  callback: C
}

export interface ActionOptionalCallback<T = any, C = IValidationCallback> {
  type: string
  payload: T
  callback?: C
}

export interface ActionCallbackOnly<C = ICallback> {
  type: string
  callback?: C
}

export interface Action<T = any> {
  type: string
  payload: T
}

export interface IAxiosResponse extends AxiosResponse {
  statusCode?: string | number
  fields?: {
    [n: string]: string
  }
}

export const DEFAULT_ITEM_LIST = {
  items: [],
  totalCount: 0,
  loading: true,
}

export interface IItemList<T> {
  items: T[]
  totalCount: number
  loading?: boolean
}

export const DEFAULT_ENTITY_ITEM_LIST = {
  entries: [],
  totalNumEntries: 0,
  loading: true,
}

export interface IEntityList<T> {
  entries: T[]
  totalNumEntries: number
  loading?: boolean
}
